import React from "react";
import Header from "../components/layout/Header";
import RoomRegister from "../components/room/RoomRegister";

const Register = () => {
  return (
    <>
      <Header />
      <RoomRegister />
    </>
  );
};

export default Register;
